import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSuperOpsPodDataByTicketId } from 'services/pod';
import { IPodData } from 'services/pod/types';

interface IProps {
  psaId: number;
  ticketId: string;
}

export const ThunkGetSuperOpsDataByTicketId = createAsyncThunk<IPodData, IProps>(
  'pod/getSuperOpsPodDataByTicketId',
  async ({ psaId, ticketId }) => getSuperOpsPodDataByTicketId(psaId, ticketId).then(r => r.data),
);
